import { useQuery } from '@tanstack/react-query';
import { queryKeys } from 'src/constants/querykeys';
import { ProductDetails } from 'src/types/catalog/ProductDetails';
import { fetchProductDetailsQuery } from './productDetailsQueryFn';

const useGetProductDetailsQuery = (
  productId: number | null,
  catalogId: number | null,
  categoryId: number | null,
  enabled: boolean = true
) =>
  useQuery<ProductDetails>({
    queryKey: [...queryKeys.product.productDetails(productId, catalogId, categoryId)],
    queryFn: fetchProductDetailsQuery,
    enabled: !!productId && !!catalogId && !!categoryId && enabled,
  });

export default useGetProductDetailsQuery;
